import { GerenciadorIntermediariasBase } from '@/domain/simulador/gerenciador-intermediarias-base'
import { PeriodicidadePagamentoEnum, type TPeriodicidadePagamentoEnum } from '@/types/simulacao'
import type { TGrupoIntermediarias } from '@/utils/calculadora-valores-totais/processador-valores-decimal'

export class GerenciadorIntermediariasSacocVParcelado extends GerenciadorIntermediariasBase {
  override criarGrupoInicial(
    datas: string[],
    valor: number = 0,
    dataPrevisaoDeEntrega?: string,
  ): TGrupoIntermediarias[] {
    if (dataPrevisaoDeEntrega && new Date(dataPrevisaoDeEntrega) < new Date()) return []
    return super.criarGrupoInicial(datas, valor)
  }

  override criarProximoGrupo(
    dataUltimaParcela?: string | null,
    periodicidade: TPeriodicidadePagamentoEnum = PeriodicidadePagamentoEnum.SemPeriodoFixo,
    dataPrevisaoDeEntrega?: string,
  ): TGrupoIntermediarias {
    if (dataPrevisaoDeEntrega && new Date(dataPrevisaoDeEntrega) < new Date()) {
      throw new Error('DataEntregaMenorQueDataAtual')
    }
    return super.criarProximoGrupo(dataUltimaParcela, periodicidade)
  }
}
